import ActiveTournaments from "./Dashboard/ActiveTournaments";
import DashboardHeader from "./Dashboard/DashboardHeader";
import PlayerStats from "./Dashboard/PlayerStats";

import { useTheme } from "@/components/context/ThemeContext";
import styles from "./tournament-dashboard.module.css";

export default function TournamentDashboard() {
  const { theme } = useTheme();

  return (
    <main
      className={`${styles.dashboard} ${theme === "dark" ? "dark" : ""} ${styles[theme]}`}
    >
      <DashboardHeader />
      <div className={styles.mainContent}>
        <div className={styles.topSection}>
          <PlayerStats />
        </div>

        <ActiveTournaments />
      </div>
    </main>
  );
}
